module.exports = __webpack_public_path__ + "img/ic_16_info.9aa7ac6f.svg";